import {useEffect,useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {useAuth} from './auth';
import {API} from './api';

export function analyticsArea(path,search='') {
 const publicAreas={'/about':'about','/contact':'contact','/how-learning-works':'how-learning-works','/sources-and-images':'sources-and-images','/impressum':'legal','/datenschutz':'privacy','/praxis-tool/home':'home','/discover':'home','/discover-v2':'home'};
 if(publicAreas[path])return publicAreas[path];
 if(path==='/praxis-tool/learning') {
  const q=new URLSearchParams(search);
  // No views of individual remedies, learning sessions, or patient data.
  if(['remedy','learn','session'].some(key=>q.has(key)))return null;
  return {home:'study',remedies:'atlas',review:'study'}[q.get('tab')||'home']||null;
 }
 return null;
}
export default function PageViewCounter(){
 const {pathname,search}=useLocation();const {user,loading}=useAuth();const last=useRef(null);
 const area=analyticsArea(pathname,search);
 useEffect(()=>{
  if(loading)return;
  if(!area||user?.is_admin){last.current=null;return;}
  if(last.current===area)return;
  last.current=area;
  fetch(`${API}/analytics/pageview`,{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json'},body:JSON.stringify({area}),keepalive:true}).catch(()=>{});
 },[area,loading,user?.is_admin]);
 return null;
}
